import React, { useState } from 'react';

export function ParagraphText(props) {
  const [showMoreToggle, setShowMoreToggle] = useState(true);
  const [value, setValue] = useState(shortText(props.value));

  function shortText() {
    return props.value?.split(/\s+/).slice(0, 10).join(' ');
  }

  const toggleClass = (event) => {
    event.preventDefault();
    const showMore = showMoreToggle === true;
    if (showMore) {
      setValue(props.value);
    } else {
      setValue(shortText());
    }
    setShowMoreToggle(!showMoreToggle);
  };

  const showToggle = props.value && props.value.length > 200;

  return (
    <div className="paragraph-text-wrapper">
      <div className="paragraph-content">{value}</div>
      {showToggle && (
        <a href="#" onClick={toggleClass} className="show-toggle-more-less">
          <p className="toggle-link">{`${showMoreToggle ? 'show more' : 'show less'}`}</p>
        </a>
      )}
    </div>
  );
}

export default ParagraphText;
